export const getAuthToken = () => {
  if (localStorage.getItem("admin_token")) {
    return localStorage.getItem("admin_token");
  }
  return "";
};

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("admin_token", token);
  }
};

export const removeAuthToken = () => {
  localStorage.clear("admin_token");
};
export const setWalletAddress = (token) => {
  localStorage.setItem("adminWalletAddress", token);
}
export const getWalletAddress = () => {
  if (localStorage.getItem('adminWalletAddress')) {
    return localStorage.getItem('adminWalletAddress')
  }
  return '';
}